module.exports = __webpack_public_path__ + "static/media/bhtpa-logo-transparent.912aa58e.png";